<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <div class="main_section01">
      <!-- Precast Concrete 전문 건설 기업
            Build a better Life -->
      <video
        v-if="getVisualType === 'V'"
        :key="videoUri"
        class="bgvid"
        id="vid0"
        autoplay=""
        loop=""
        muted=""
        playsinline=""
      >
        <!--source :src="`${resources}file/a_movie.mp4`" type="video/mp4" /-->
        <source :src="videoUri" type="video/mp4" />
      </video>
      <img
        v-else-if="getVisualType === 'I'"
        class="bgimg"
        :src="videoUri"
        :alt="getTitle"
      />
      <div class="video_txt">
        <span class="txt1" v-html="getSubTitle"></span>
        <span class="txt2" v-html="getTitle"></span>
      </div>

      <div class="img_scroll"></div>
    </div>

    <div class="main_section02">
      <div class="section02_txt">PC 공법의 선구자 한국오션플랫폼</div>
      <p class="section02_txt2">
        지난 53여 년간 국민 주택 보급과 PC 관련 건설분야의 선두주자로서<br />한국오션플랫폼은
        창의적인 생각과 열정, 끊임없는 혁신과 도전으로 더 나은 세상을 만들어
        갑니다.
      </p>
      <ul class="main_section02_list">
        <li>
          <p>한국오션플랫폼 창립</p>
          <div>
            <NumMotion :maxiMum="53" :numSpeed="500" :numDelay="300" />
            <span> 주년</span>
          </div>
        </li>
        <li>
          <p>연 생산량</p>
          <div>
            <NumMotion :maxiMum="36" :numSpeed="500" :numDelay="900" />
            <span> 만 ㎥</span>
          </div>
        </li>
        <li>
          <p>누적 시공실적</p>
          <div>
            <NumMotion :maxiMum="450" :numSpeed="500" :numDelay="1200" />
            <span> 건</span>
          </div>
        </li>
        <li>
          <p>매출액</p>
          <div>
            <NumMotion :maxiMum="2884" :numSpeed="500" :numDelay="1500" />
            <span> 억원</span>
            <p>(2023년 기준)</p>
          </div>
        </li>
      </ul>
    </div>

    <div class="main_section03">
      <div class="main_cont">
        <div class="section03_cont">
          <h2>주요연혁</h2>
          <p class="section03_txt">
            <span
              >한국오션플랫폼은 혁신을 거듭하여<br />PC(Precast Concrete)
              관련<br />제조 건설 분야에서 선도기업으로 성장해왔습니다.
            </span>
          </p>
        </div>
        <div class="mainSwiper swiper-container" ref="mainSwiperRef">
          <ul class="swiper-wrapper">
            <!-- <li class="swiper-slide">
              <img :src="`${resources}img/main_slide01.png`" alt="" />
              <dl>
                <dt>2024</dt>
                <dd>
                  <ul>
                    <li>한국오션플랫폼㈜ 사명 변경</li>
                    <li>LS그룹 계열 분리</li>
                  </ul>
                </dd>
              </dl>
            </li> -->

            <li class="swiper-slide">
              <img :src="`${resources}img/main_slide01.png`" alt="" />
              <dl>
                <dt>2021</dt>
                <dd>
                  <ul>
                    <li>㈜한성과 한성PC건설㈜ 합병</li>
                    <li>존속법인 한성PC건설㈜ 출범</li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li class="swiper-slide">
              <img :src="`${resources}img/main_slide02.png`" alt="" />
              <dl>
                <dt>2020</dt>
                <dd>
                  <ul>
                    <li>
                      아산PC공장 HCS 생산 LINE 설비 <br />(27 BED, 국내 최대)
                    </li>
                    <li>*HCS : Hollow Core Slab</li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li class="swiper-slide">
              <img :src="`${resources}img/main_slide03.png`" alt="" />
              <dl>
                <dt>2015</dt>
                <dd>
                  <ul>
                    <li>삼성물산 음성PC공장 인수</li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li class="swiper-slide">
              <img :src="`${resources}img/main_slide04.png`" alt="" />
              <dl>
                <dt>2009</dt>
                <dd>
                  <ul>
                    <li>㈜한성에서 물적 분할하여 <br />한성PC건설㈜ 설립</li>
                    <li>LS그룹으로 편입</li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li class="swiper-slide">
              <img :src="`${resources}img/main_slide05.png`" alt="" />
              <dl>
                <dt>2004</dt>
                <dd>
                  <ul>
                    <li>㈜한성과 세일산업㈜ 합병</li>
                    <li>존속법인 ㈜한성 출범</li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li class="swiper-slide">
              <img :src="`${resources}img/main_slide06.png`" alt="" />
              <dl>
                <dt>1996</dt>
                <dd>
                  <ul>
                    <li>㈜한성 아산PC공장 준공</li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li class="swiper-slide">
              <img :src="`${resources}img/main_slide07.png`" alt="" />
              <dl>
                <dt>1978</dt>
                <dd>
                  <ul>
                    <li>㈜한성으로 상호 변경</li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li class="swiper-slide">
              <img :src="`${resources}img/main_slide08.png`" alt="" />
              <dl>
                <dt>1971</dt>
                <dd>
                  <ul>
                    <li>
                      한성프리훼브㈜ 설립 <br />(대한주택공사와 일본 대성건설㈜
                      합작)
                    </li>
                    <li>판교PC공장 준공</li>
                  </ul>
                </dd>
              </dl>
            </li>
          </ul>
        </div>
        <div class="swiper_navi">
          <a href="#" class="main-button-prev"></a>
          <a href="#" class="main-button-next"></a>
        </div>
      </div>
    </div>

    <div class="main_section04">
      <div class="main_cont">
        <h2>사업분야</h2>
        <ul class="main_list">
          <li>
            <router-link :to="{ path: '/tech/p_tech012' }">
              <a href="#" class="box_section04">
                <p class="main_list_tit">PC 사업</p>
                <p class="main_list_txt">
                  빠르고, 쉽게<br />새로운 건설 패러다임을 만듭니다.
                </p>
              </a>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/tech/p_tech034' }">
              <a href="#" class="box_section04">
                <p class="main_list_tit">건축 사업</p>
                <p class="main_list_txt">
                  고객에게 최상의 가치를<br />실현해 드립니다.
                </p>
              </a>
            </router-link>
          </li>
          <li>
            <router-link :to="{ path: '/tech/p_tech035' }">
              <a href="#" class="box_section04">
                <p class="main_list_tit">시행 사업</p>
                <p class="main_list_txt">
                  고객의 라이프 스타일에 맞는 <br />문화를 만들어 갑니다.
                </p>
              </a>
            </router-link>
          </li>
        </ul>
      </div>

      <ul class="section04_list">
        <li><img :src="`${resources}img/main_section04_01.png`" alt="" /></li>
        <li>
          <img :src="`${resources}img/main_section04_02.png`" alt="" />
          <router-link
            :to="{
              path: '/tech/p_tech012#tab3',
              query: { scrollTo: '#factory1' },
            }"
          >
            <a href="#" class="section04_list_con">
              <strong>아산공장<span>since 1996</span></strong>
              <dl>
                <dt>위치</dt>
                <dd>충청남도 아산시 영인면 토정샘로 66</dd>
              </dl>
              <dl>
                <dt>공장면적</dt>
                <dd>180,387 m<sup>2</sup> (축구장의 25배/54,567평)</dd>
              </dl>
              <dl>
                <dt>연간 생산능력</dt>
                <dd>240,000 m<sup>3</sup></dd>
              </dl>
              <p class="info_txt">“국내최대 공급 물량” HCS 27개 Line 보유</p>
            </a>
          </router-link>
        </li>
        <li>
          <img :src="`${resources}img/main_section04_03.png`" alt="" />
          <router-link
            :to="{
              path: '/tech/p_tech012#tab3',
              query: { scrollTo: '#factory2' },
            }"
          >
            <a href="#" class="section04_list_con">
              <strong>음성공장<span>since 2015</span></strong>
              <dl>
                <dt>위치</dt>
                <dd>충청북도 음성군 감곡면 가곡로 335</dd>
              </dl>
              <dl>
                <dt>공장면적</dt>
                <dd>166,456 m<sup>2</sup> (축구장의 24배/50,353평)</dd>
              </dl>
              <dl>
                <dt>연간 생산능력</dt>
                <dd>120,000 m<sup>3</sup></dd>
              </dl>
            </a>
          </router-link>
        </li>
        <li><img :src="`${resources}img/main_section04_04.png`" alt="" /></li>
      </ul>
    </div>

    <!--div class="main_section05">
      <div class="main_bg">
        <div class="main_cont">
          <div class="question_wrap">
            <h2>고객문의</h2>
            <div class="tit_img">
              <strong
                >“한성PC건설은 여러분의 소중한 의견을 받고 있습니다.”</strong
              >
              <div>궁금하신 사항을 문의해 주시기 바랍니다.</div>
            </div>
            <div class="question_box">
              <ValidationObserver ref="validFormRef" v-slot="{ reset }" slim>
                <form ref="formRef" @reset.prevent="reset">
                  <fieldset>
                    <legend>고객문의</legend>
                    <ValidationProvider
                      name="category"
                      rules="required"
                      v-slot="{ classes }"
                      slim
                    >
                      <div class="selectbox3 main" :class="classes">
                        <v-select
                          v-model="category"
                          placeholder="선택하세요"
                          :options="options"
                          :searchable="false"
                        >
                        </v-select>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="name"
                      rules="required"
                      v-slot="{ classes }"
                      slim
                    >
                      <input
                        v-model="name"
                        :class="classes"
                        type="text"
                        placeholder="이름(회사)"
                      />
                    </ValidationProvider>
                    <ValidationProvider
                      name="email"
                      rules="required|email"
                      v-slot="{ classes }"
                      slim
                    >
                      <input
                        v-model="email"
                        :class="classes"
                        type="text"
                        placeholder="이메일"
                      />
                    </ValidationProvider>
                    <ValidationProvider
                      name="question"
                      rules="required"
                      v-slot="{ classes }"
                      slim
                    >
                      <textarea
                        v-model="question"
                        :class="classes"
                        placeholder="메세지"
                      ></textarea>
                    </ValidationProvider>
                  </fieldset>
                </form>
              </ValidationObserver>
              <a href="#" class="btn_send" @click.prevent="onSend">SEND</a>
            </div>
          </div>
        </div>
      </div>
    </div-->
  </div>
  <!--// container -->
</template>

<script>
/* eslint-disable camelcase */
import inquiry from '@/mixins/inquiry';
import page from '@/mixins/page';
import Cookies from 'js-cookie';
import { defaultTo, get } from 'lodash-es';
import Swiper from 'swiper';
import { mapMutations, mapState } from 'vuex';

import NumMotion from '@/components/TMain/NumMotion.vue';

/**
 * @module pages/main PC
 * @desc 메인
 * @vue-data {Object} videoInfo={} - 영상 정보
 * @vue-data {String} videoInfo.file_path=null - URL
 * @vue-data {String} videoInfo.file_type=null - 파일 타입
 * @vue-data {String} videoInfo.sub_title=null - 서브 타이틀
 * @vue-data {String} videoInfo.title=null - 타이틀
 * @vue-computed {Number} scrollTop - 현재 스크롤
 * @vue-computed {Boolean} showTopBanner - 탑 배너 체크
 * @vue-computed {String} getVisualType - 영상 파일 타입 업데이트
 * @vue-computed {String} getTitle - 영상 타이틀 업데이트
 * @vue-computed {String} getSubTitle - 영상 서브 타이틀 업데이트
 * @vue-computed {String} videoUri - 영상 URL 업데이트
 */
export default {
  mixins    : [page, inquiry],
  components: {
    NumMotion
  },
  data() {
    return {
      videoInfo: {
        file_path: null,
        file_type: null,
        sub_title: null,
        title    : null
      }
    };
  },
  computed: {
    ...mapState('view', {
      scrollTop: 'scrollTop'
    }),
    ...mapState('main', {
      showTopBanner: 'showTopBanner'
    }),
    getVisualType() {
      return defaultTo(get(this.videoInfo, 'file_type'));
    },
    getTitle() {
      return defaultTo(get(this.videoInfo, 'title'), '').replaceAll(
        '#줄#',
        '<br />'
      );
    },
    getSubTitle() {
      return defaultTo(get(this.videoInfo, 'sub_title'), '').replaceAll(
        '#줄#',
        '<br />'
      );
    },
    videoUri() {
      return this.videoInfo
        ? this.axios.defaults.baseURL + this.videoInfo.file_path
        : '';
    }
  },
  watch: {
    scrollTop(value) {
      const show = value === 0;
      if (this.showTopBanner !== show && !Cookies.get('todayClose')) {
        this.setShowTopBanner(show);
      }
    }
  },
  created() {},
  mounted() {
    this.setIsMain(true);
    this.loadVideo();
    new Swiper(this.$refs.mainSwiperRef, {
      slidesPerView: 'auto',
      loop         : true,
      navigation   : {
        // 버튼 사용자 지정
        nextEl: '.main-button-next',
        prevEl: '.main-button-prev'
      }
    });
  },
  methods: {
    ...mapMutations('main', {
      setIsMain       : 'SET_IS',
      setShowTopBanner: 'SET_SHOW_TOP_BANNER'
    }),

    /**
     * 통신 후 비디오 정보 업데이트
     */
    loadVideo() {
      this.axios
        .get('/api/getVideo.do', {
          params: {
            platform: 'P'
          }
        })
        .then((res) => {
          this.videoInfo = get(res, 'data.item');
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
